import { Typography } from "@mui/material";

import { EWeightMeasurementUnit } from "../../../../../../@types";
import { convertWeight } from "../../../../../../utils";
import { ExplanationPopover } from "../../../../../common/ExplanationPopover/ExplanationPopover";
import { usePreviewCourse } from "../../hooks/usePreviewCourse";

export function CoursePrerequisites() {
	const { course } = usePreviewCourse();

	if (!course) {
		return null;
	}

	if (!course.note && !course.minWeight && !course.maxWeight) {
		return null;
	}

	let minWeightText = "";
	if (course.minWeight) {
		minWeightText = `${convertWeight(
			Number(course.minWeight.split(" ")[0]),
			course.minWeight.split(" ")[1] as EWeightMeasurementUnit,
			EWeightMeasurementUnit.POUND,
		)} lbs <`;
	}

	let maxWeightText = "";
	if (course.maxWeight) {
		maxWeightText = `< ${convertWeight(
			Number(course.maxWeight.split(" ")[0]),
			course.maxWeight.split(" ")[1] as EWeightMeasurementUnit,
			EWeightMeasurementUnit.POUND,
		)} lbs`;
	}

	let weightLimit = "";
	if (minWeightText || maxWeightText) {
		weightLimit = `${minWeightText} Weight ${maxWeightText}`.trim();
	}

	return (
		<div className="course-prerequisites-container">
			<Typography className="big-text black-label">Prerequisites</Typography>
			{course.note && (
				<Typography
					className="normal-text"
					textAlign="justify"
					whiteSpace="break-spaces">
					{course.note}
				</Typography>
			)}
			{weightLimit && (
				<div className="weight-container">
					<ExplanationPopover text="For safety of flight, the aircraft in use requires you to be within this weight range." />

					<Typography className="normal-text">{weightLimit}</Typography>
				</div>
			)}
			<div className="separator" />
		</div>
	);
}
